import { proxyCustomElement, HTMLElement, h } from '@stencil/core/internal/client';
import { W as WppIcon } from './WppIcon.js';

const wppIconCss = ":host{display:-ms-inline-flexbox;display:inline-flex;color:var(--wpp-prop-icon-color)}";

const WppIconAction$1 = /*@__PURE__*/ proxyCustomElement(class WppIconAction extends HTMLElement {
  constructor() {
    super();
    this.__registerHost();
    this.__attachShadow();
    this.size = 'm';
    this.width = undefined;
    this.height = undefined;
    this.color = 'var(--wpp-icon-color)';
  }
  render() {
    return (h(WppIcon, { name: "wpp-icon-action", width: this.width, height: this.height, size: this.size, color: this.color }, h("path", { "fill-rule": "evenodd", "clip-rule": "evenodd", d: "M9.12428 2C9.53849 2 9.87428 2.33579 9.87428 2.75V4.34357C9.87428 4.75778 9.53849 5.09357 9.12428 5.09357C8.71007 5.09357 8.37428 4.75778 8.37428 4.34357V2.75C8.37428 2.33579 8.71007 2 9.12428 2ZM14.0369 4.21163C14.3298 4.50452 14.3298 4.9794 14.0369 5.27229L12.8417 6.46747C12.5489 6.76036 12.074 6.76036 11.7811 6.46747C11.4882 6.17458 11.4882 5.6997 11.7811 5.40681L12.9763 4.21163C13.2692 3.91874 13.744 3.91874 14.0369 4.21163ZM4.21163 4.21163C4.50453 3.91874 4.9794 3.91874 5.27229 4.21163L6.46747 5.40681C6.76036 5.6997 6.76036 6.17458 6.46747 6.46747C6.17458 6.76036 5.6997 6.76036 5.40681 6.46747L4.21163 5.27229C3.91874 4.9794 3.91874 4.50452 4.21163 4.21163ZM8.46676 9.81764C8.10245 8.88537 9.0221 7.96573 9.95436 8.33003L17.4063 11.242C18.38 11.6225 18.3803 13.0002 17.4068 13.3811L14.6116 14.4749L13.5178 17.2701C13.1369 18.2436 11.7592 18.2432 11.3788 17.2696L8.46676 9.81764ZM10.156 10.0193L12.4486 15.8861L13.3343 13.6227C13.4105 13.4279 13.5646 13.2738 13.7594 13.1976L16.0229 12.3119L10.156 10.0193ZM2.75 8.37428L4.34357 8.37428C4.75778 8.37428 5.09357 8.71007 5.09357 9.12428C5.09357 9.53849 4.75778 9.87428 4.34357 9.87428L2.75 9.87428C2.33579 9.87428 2 9.53849 2 9.12428C2 8.71007 2.33579 8.37428 2.75 8.37428ZM6.46747 11.7811C6.76036 12.074 6.76036 12.5489 6.46747 12.8417L5.27229 14.0369C4.9794 14.3298 4.50453 14.3298 4.21163 14.0369C3.91874 13.744 3.91874 13.2692 4.21163 12.9763L5.40681 11.7811C5.6997 11.4882 6.17458 11.4882 6.46747 11.7811Z", fill: "currentColor" })));
  }
  static get registryIs() { return "wpp-icon-action-v2-21-0"; }
  static get style() { return wppIconCss; }
}, [1, "wpp-icon-action", "wpp-icon-action-v2-21-0", {
    "size": [1],
    "width": [2],
    "height": [2],
    "color": [1]
  }]);
function defineCustomElement$1() {
  if (typeof customElements === "undefined") {
    return;
  }
  const components = ["wpp-icon-action-v2-21-0"];
  components.forEach(tagName => { switch (tagName) {
    case "wpp-icon-action-v2-21-0":
      if (!customElements.get(tagName)) {
        customElements.define(tagName, WppIconAction$1);
      }
      break;
  } });
}

const WppIconAction = WppIconAction$1;
const defineCustomElement = defineCustomElement$1;

export { WppIconAction, defineCustomElement };
